import React from "react";
import ThemeToggle from "./ThemeToggle";
import { profile } from "../../data/portfolio";

const SiteHeader = ({ dark, onToggleTheme }) => {
  return (
    <header className="relative z-10 flex min-h-0 items-start justify-between gap-6 md:min-h-[196px]">
      <div className="pointer-events-none absolute right-[72px] top-0 z-[3] w-[140px] drop-shadow-[0_18px_28px_rgba(0,0,0,0.18)] max-md:hidden">
        <div className="aspect-[5/7] w-full overflow-hidden rounded-xl border border-zinc-200 bg-white dark:border-zinc-800 dark:bg-zinc-900">
          <img
            src={profile.badgePhoto}
            alt=""
            className="h-full w-full object-cover grayscale contrast-105"
          />
        </div>
      </div>

      <div className="min-w-0">
        <h1 className="m-0 whitespace-nowrap text-5xl font-semibold tracking-tight text-zinc-950 dark:text-zinc-50 sm:text-6xl">
          {profile.name}
        </h1>
        <nav className="mt-5 text-sm font-medium text-zinc-800 dark:text-zinc-200" aria-label="Social links">
          {profile.links.map((link, index) => (
            <React.Fragment key={link.label}>
              {index > 0 && (
                <span className="mx-2 font-normal text-zinc-400 dark:text-zinc-600">/</span>
              )}
              <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline underline-offset-2"
              >
                {link.label}
              </a>
            </React.Fragment>
          ))}
        </nav>
      </div>

      <ThemeToggle dark={dark} onToggle={onToggleTheme} />
    </header>
  );
};

export default SiteHeader;
